import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Accueil', href: '/' },
    { name: 'Services OSINT', href: '/osint' },
    { name: 'Services Pentest', href: '/pentest' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <nav className="fixed w-full z-50 px-4 sm:px-6 lg:px-8 top-5">
      <div className="max-w-7xl mx-auto">
        
        {/* Conteneur principal */}
        <div className="bg-[#F6FAFD] rounded-full px-7 py-2.5 flex items-center justify-between shadow-[0_10px_40px_rgba(10,25,49,0.06)] border border-[#B3CFE5]/25 backdrop-blur-md">
          
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer">
            <Link to="/">
              <span className="text-[22px] font-black text-[#0A1931] tracking-tighter">Nodixs</span>
            </Link>
          </div>

         
          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;

              return (
                <Link
                  key={link.name}
                  to={link.href}
                  className={`relative px-4 py-2 text-[13px] font-bold transition-colors duration-300 group ${
                    isActive ? 'text-[#4A7FA7]' : 'text-[#1A3D63] hover:text-[#4A7FA7]'
                  }`}
                >
                  <span className="relative z-10">{link.name}</span>

                  {/* Underline dynamique */}
                  <span className={`absolute inset-x-4 bottom-1 h-0.5 bg-[#4A7FA7] transition-transform duration-300 origin-left ${
                    isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                  }`} />
                </Link>
              );
            })}
          </div>

          {/* Groupe de Boutons d'Action - Desktop */}
          <div className="hidden lg:flex items-center space-x-3">
            {/* Bouton secondaire qui prend la couleur de survol pleine du premier bouton */}
            <button
            onClick={() => {navigate('/audit-test')}}
            className="border border-[#0A1931] text-[#0A1931] px-5 py-2 rounded-full text-[12px] font-bold transition-all duration-200 hover:bg-[#1A3D63] hover:border-[#1A3D63] hover:text-[#F6FAFD] active:scale-95">
              Faire un test en ligne
            </button>
            
            {/* CTA Principal */}
            <Link to="/rdv">
              <button className="bg-[#0A1931] text-[#F6FAFD] px-5 py-2 rounded-full text-[12px] font-bold transition-all duration-200 hover:bg-[#1A3D63] active:scale-95 shadow-sm">
                Demander un audit
              </button>
            </Link>
          </div>

          {/* Mobile Toggle */}
          <div className="lg:hidden text-[#0A1931]">
            <button onClick={() => setIsOpen(!isOpen)} className="p-1.5 flex items-center justify-center">
              {isOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.98, y: -10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.98, y: -10 }}
            className="absolute top-20 left-4 right-4 bg-[#F6FAFD] rounded-[2rem] p-6 shadow-2xl border border-[#B3CFE5]/30 lg:hidden"
          >
            <div className="flex flex-col space-y-1.5">
              {navLinks.map((link) => {
                const isActive = location.pathname === link.href;

                return (
                  <Link
                    key={link.name}
                    to={link.href}
                    onClick={() => setIsOpen(false)}
                    className={`text-left text-[15px] font-bold p-3.5 rounded-xl transition-all ${
                      isActive ? 'bg-[#B3CFE5]/25 text-[#0A1931]' : 'text-[#1A3D63]'
                    }`}
                  >
                    {link.name}
                  </Link>
                );
              })}

             
              <div className="pt-4 flex flex-col space-y-3">
                <button
                 onClick={() => {navigate('/audit-test'); setIsOpen(false);}}
                 className="border border-[#0A1931] text-[#0A1931] w-full py-3.5 rounded-xl font-bold text-[14px] transition-all active:bg-[#1A3D63] active:border-[#1A3D63] active:text-[#F6FAFD]">
                  Faire un test en ligne
                </button>
                <Link to="/rdv" onClick={() => setIsOpen(false)} className="w-full">
                  <button className="bg-[#0A1931] text-[#F6FAFD] w-full py-3.5 rounded-xl font-bold text-[14px] shadow-lg text-center transition-colors active:bg-[#1A3D63]">
                    Demander un audit
                  </button>
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
